$(function () {

    var applicationForm = $(".application-form-wrapper");

    if (applicationForm.length)
    {
        $('.chk-preferred-office').change(function () {
            var str = $('.chk-preferred-office:checked').map(function () {
                return this.value;
            }).get().join();

            $('#PreferredOffice').val(str);
        });
    }
});